export default "__VITE_ASSET__xk3ZBiwt__"